<template>
  <svg class="order-one" width="109.33" height="68.67" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 109.33 68.67"><path fill="#ff6e6e" d="M0 0h109.33v68.67H0z"/><path fill="#fc9d9d" d="M56.5 0h52.83v68.67H56.5z"/><path fill="#ff8080" d="M56.5 0l19.83 43.67h17l16-43.67v68.67H56.5V0z"/><path fill="#ebebe6" d="M30.17 44.91h19.5v16.33h-19.5z"/><path fill="none" stroke="#000" stroke-miterlimit="10" d="M33.38 48.17v9.56m5-9.56v9.56m6.7-9.56v9.56"/><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width=".4" d="M35.13 48.17v9.56m1-9.56v9.56M40 48.17v9.56m1-9.56v9.56m1-9.56v9.56m1.54-9.56v9.56"/></svg>
</template>

<script>
export default {
  name: 'OrderOne'
}
</script>

<style lang="scss" scoped>
.order-one {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 2;
  animation: 0.55s bounce both;
  transform-origin: center bottom;
}
</style>
